function LoadingScreen() {
  return null;
}

export default LoadingScreen;
